import { render, staticRenderFns } from "./linear-scale.vue?vue&type=template&id=04bffe64&scoped=true&"
import script from "./linear-scale.vue?vue&type=script&lang=js&"
export * from "./linear-scale.vue?vue&type=script&lang=js&"
import style0 from "./linear-scale.vue?vue&type=style&index=0&id=04bffe64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bffe64",
  null
  
)

export default component.exports